import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  HideOnFormToggle,
  StandardDesignConfig,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const SingleChoiceStyleSelect = {
  label: 'Style',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'style',
  dynamicChoices: ({ maximum, keyField, entry_values }) => [
    {
      label: 'Radio',
      value: 1,
      isDisabled: keyField,
      additionalProperties: {
        reference_data_id: null,
        reference_data_column: null,
        reference_data_screen_id: null,
        dependent_entry: null, // is this right?
        description: 'Single Choice Radio',
      },
    },
    {
      label: 'Boxes',
      value: 5,
      isDisabled: keyField,
      additionalProperties: {
        entry_values: entry_values.length
          ? entry_values.filter(x => x.text).slice(0, Math.min(maximum, 5))
          : Array.from({ length: Math.min(maximum, 5) }),
        maximum: Math.min(maximum, 5),
        entry_values: entry_values.slice(0, Math.min(maximum, 5)),
        reference_data_id: null,
        reference_data_column: null,
        reference_data_screen_id: null,
        dependent_entry: null, // is this right?
        description: 'Single Choice Boxes',
      },
    },
  ],
}

export const SingleChoiceStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  SingleChoiceStyleSelect,
  RequiredToggle,
  ...StandardDesignConfig,
  HideOnFormToggle,
]
